import React from "react";
import type { BoardProps } from "../pages/room";
import { LudoBoard } from "./ludo";
import { DominoBoard } from "./domino";
import { JackarooBoard } from "./jackaroo";
import { MemoryBoard } from "./memory";
import { PoolBoard } from "./pool";
import { CarromBoard } from "./carrom";

export function Board(props: BoardProps & { gameId: string }) {
  switch (props.gameId) {
    case "ludo":
      return <LudoBoard {...props} />;
    case "domino":
      return <DominoBoard {...props} />;
    case "jackaroo":
      return <JackarooBoard {...props} />;
    case "memory":
      return <MemoryBoard {...props} />;
    case "billiards":
      return <PoolBoard {...props} />;
    case "carrom":
      return <CarromBoard {...props} />;
  }
  return null;
}

export { SEAT_COLORS } from "./colors";
